import { render, staticRenderFns } from "./CreateCrowdJudgement.vue?vue&type=template&id=bd43c414&scoped=true"
import script from "./CreateCrowdJudgement.vue?vue&type=script&lang=js"
export * from "./CreateCrowdJudgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43c414",
  null
  
)

export default component.exports